import React from "react";
import { Image } from "antd-mobile";
import failureImg from "../img/dataCenterFailure.png";

import "../index.scss";
import logoIcon from "pages/DataCenter/images/logo.png";
export default function DataCenterFailure() {
  return (
    <div className="data-center-failure-wrapper">
      <div className="failureImg_box">
        <img src={failureImg} alt="" />
      </div>
      <div>抱歉，该披露信息已失效！</div>
      {/* <div className="data_center_logo">
        <Image src={logoIcon} />
      </div> */}
    </div>
  );
}
